import React from 'react'
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import $ from 'jquery';
import { withRouter } from 'react-router-dom';
import { inativarVendaSite } from '../../actions/itinerario/ativarInativarItinerarioVendaSite';
import {alterarExibicaoDetalhamentoRotaItinerario} from '../../actions/rota-itinerario/alterarExibicacaoDetalhamentoRotaItinerario';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalInativarVendaSiteItinerario extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            idItinerarios: []
        };
    }

    fecharModal() {
        $('#modalInativarVendaSiteItinerario')
            .modal('hide');
        $('#modalInativarVendaSiteItinerario')
            .hide();
        $('.modal-backdrop')
            .hide();
    }

    adicionarReservas(itinerarioId) {
        let itinerariosIds = this.state.idItinerarios;
        const jaExisteItinerario = itinerariosIds.filter(it => it === itinerarioId)
        if (jaExisteItinerario.length > 0) {
            itinerariosIds = itinerariosIds.filter(it => it !== itinerarioId)
            this.setState({ idItinerarios: itinerariosIds })
        } else {
            itinerariosIds.push(itinerarioId);
            this.setState({ idItinerarios: itinerariosIds })
        }
    }

    submit() {
        this.props.inativarVendaSite(this.state.idItinerarios).then(
            () => {
                this.fecharModal();
                showSuccessMsg('Itinerário(s) desabilitado(s) para o site com sucesso.')
                this.props.alterarExibicaoDetalhamentoRotaItinerario(this.props.rotaSelecionada, true)
                this.setState({idItinerarios: []})
            })
    }

    adicionarTodosItinerarios(itinerarios) {
        itinerarios = itinerarios.map(it => {
            return it.id
        })
        this.setState({ idItinerarios: itinerarios })
    }

    removerTodosItinerarios() {
        this.setState({ idItinerarios: [] })
    }

    inputCheck(itinerarioId) {
        return (<input className='ml-3' name='habilitadoBpe' type="checkbox"
            label="Habilitar para emissão de BPe"
            css="form-check-input"
            value={itinerarioId}
            checked={this.state.idItinerarios.filter(it => it === itinerarioId).length > 0}
            onClick={() => this.adicionarReservas(itinerarioId)} />)
    }

    dividirItinerariosParaATabela(itinerarios) {
        if (itinerarios !== null) {
            itinerarios = itinerarios.filter(it => it.habilitadoSite === true)
            let novoArray = [];
            let corte = 3;
            for (let i = 0; i < itinerarios.length; i = i + corte) {
                novoArray.push(itinerarios.slice(i, i + corte));
            }
            return this.mostrarTabela(novoArray);
        }
    }

    mostrarTabela(array) {
        return array.map((it, index) => <tr key={index}>
            {it.map((itinerario, indice) => <td colSpan={4} className='text-center' key={indice}>
                {itinerario.dataHoraPartida} {this.inputCheck(itinerario.id)}</td>
            )}
        </tr>
        );
    }

    render() {
        const {
            handleSubmit
        } = this.props;
        const itinerarios = this.props.itinerariosSelecionados;
        (itinerarios)
        return (
            <div className="modal fade show" id='modalInativarVendaSiteItinerario' role='dialog'
                aria-labelledby='modalInativarVendaSiteItinerario' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-md'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Itinerários Ativos</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={() => this.removerTodosItinerarios()}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='mb-2'>
                                <button className="btn btn-laranja mr-2"
                                    onClick={() => this.adicionarTodosItinerarios(itinerarios)}>
                                    Selecionar todos
                                </button>
                                <button className="btn btn-laranja"
                                    onClick={() => this.removerTodosItinerarios()}
                                    disabled={!this.state.idItinerarios.length > 0}>
                                    Desmarcar todos
                                </button>
                            </div>
                            <form onSubmit={handleSubmit(this.submit.bind(this))}>
                                <div className="lista-table">
                                    <div className='table-responsive'>
                                        <table className="table table-striped table-bordered" style={{ backgroundColor: '#FFF' }}>
                                            <tbody>
                                                {this.dividirItinerariosParaATabela(itinerarios)}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" disabled={!this.state.idItinerarios.length > 0}
                                        className="btn btn-laranja">Inativar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        itinerariosSelecionados: state.itinerariosSelecionados,
        rotaSelecionada: state.rotaSelecionada
    }
}

export default withRouter(connect(mapStateToProps, {
    inativarVendaSite,
    alterarExibicaoDetalhamentoRotaItinerario
})(reduxForm({
    form: 'formAtivarInativarItinerario',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalInativarVendaSiteItinerario)));
